var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader"},[_c('div',{staticClass:"preloader__icon"},[_c('img',{attrs:{"src":require("../../public/img/telemedicine-widget-images/preloader-spinner.svg")}})])])
}]

export { render, staticRenderFns }